import { analysisRunner } from "@/features/analysis/analysis-runner";
import { useAnalysisDataStore } from "@/features/analysis/analysis-data.store";
import { nikolaRunSessions } from "@/features/chat/messaging/use-nikola-run";
import { useGamesStore } from "@/features/games/games.store";
import { usePatternsStore } from "@/features/patterns/patterns.store";
import { resetPageState } from "@/features/preferences/page-state";
import { useBoardStore } from "@/shared/stores/board.store";
import { relinkMyChessAccount } from "./profile.api";
import { useProfileStore } from "./profile.store";

export const relinkChessAccount = async (username: string): Promise<boolean> => {
  const owner = useProfileStore.getState().ownerUserId;
  const profile = await relinkMyChessAccount(username);
  if (useProfileStore.getState().ownerUserId !== owner) return false;
  analysisRunner.stop();
  resetPageState();
  useGamesStore.getState().setOwner(null);
  useGamesStore.getState().setOwner(owner);
  useAnalysisDataStore.getState().invalidateGames();
  usePatternsStore.getState().invalidateEvidence();
  nikolaRunSessions.setOwner(null);
  nikolaRunSessions.setOwner(owner);
  useBoardStore.setState(useBoardStore.getInitialState());
  useProfileStore.getState().replaceProfile(profile);
  try {
    for (const key of Object.keys(sessionStorage)) {
      if (key.startsWith("chessla:focus:") || key === "chessla:profile-stat-show-seen") sessionStorage.removeItem(key);
    }
  } catch {
    // Browser storage may be unavailable; in-memory evidence is still reset.
  }
  return true;
};
